module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="base-form js-password-reset-form">\n	<h1>Forgotton 2017 '+
((__t=( game_title ))==null?'':_.escape(__t))+
' password</h1>\n	<p>We can reset your password for your 2017 registered '+
((__t=( game_title ))==null?'':_.escape(__t))+
' account, allowing you to create another 2017 password to login and link with your new NRL Account. Enter your 2017 registered email below and we will email you steps to complete the process.</p>\n	<div class="form-group">\n		<input type="text" id="email" name="email" class="js-email" placeholder="Enter 2017 registered email address" value="'+
((__t=( email ))==null?'':_.escape(__t))+
'">\n		';
 if (errors && errors.email) { 
__p+='\n			<div class="error">'+
((__t=( errors.email[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n		';
 if (errors && errors.server_side) { 
__p+='\n			<div class="error">'+
((__t=( errors.server_side[0] ))==null?'':__t)+
'</div>\n		';
 } 
__p+='\n	</div>\n	<div class="buttons-wrapper">\n		<button type="button" class="btn secondary-btn js-cancel">Cancel</button>\n		<button type="submit" class="btn primary-btn js-send">Send</button>\n	</div>\n</form>';
}
return __p;
};
